/**
 * Non-persistent, ephemeral mode: the table still reads its view from the URL,
 * but writes NOTHING back to localStorage — the user's saved view is left
 * intact. A `noSave` URL therefore *defines* the view on its own; nothing may
 * leak in from the viewer's stored state.
 */
export const NO_SAVE_PARAM_NAME = "noSave";

export function isNoSaveUrl(params: URLSearchParams): boolean {
    return params.has(NO_SAVE_PARAM_NAME);
}

export function isNoSaveActive(): boolean {
    if (typeof window === "undefined") {
        return false;
    }
    return isNoSaveUrl(new URLSearchParams(window.location.search));
}
